import { Combobox } from '@headlessui/react'
import clsx from '@vangst/lib/clsx'
import {
  MemberComputed,
  MemberOptions,
  MemberVars,
} from '@vangst/services/oogst/member/useMember'
import { MdCheckBox, MdCheckBoxOutlineBlank } from 'react-icons/md'
import Avatar from '../../../components/views/Avatar'

type PropsType = React.HTMLAttributes<HTMLDivElement> & {
  readonly jobPostingId?: string
  readonly member?: MemberComputed
  readonly title: string
  readonly uri: string
  readonly variables?: MemberVars
  readonly options?: MemberOptions
}

function MemberMenuItem(props: PropsType) {
  const { className, member, title, uri, variables, options, ...rest } = props
  return (
    <Combobox.Option
      as="div"
      key={member?.id ?? uri}
      value={member?.username ?? uri}
      className={clsx(
        'group/comboboxoption flow-x-xs mood-white cursor-pointer items-center p-2',
        'aria-selected:mood-green hocus:mood-green aria-selected:font-600',
        className,
      )}
      title={title}
      {...rest}
    >
      <span className="text-orange">
        <MdCheckBox
          aria-hidden="true"
          className="hidden group-aria-selected/comboboxoption:inline"
        />
        <MdCheckBoxOutlineBlank
          aria-hidden="true"
          className="group-aria-selected/comboboxoption:hidden"
        />
      </span>
      <Avatar
        alt={member?.initials ?? '...'}
        className="size-8"
        src={member?.avatarUrl}
      />
      <span>{member?.fullName ?? title}</span>
    </Combobox.Option>
  )
}

export default MemberMenuItem
